"use client";
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as r, jsxs as e } from "react/jsx-runtime";
import m from "./stack.js";
import v from "./inline.js";
import x from "./box.js";
import { useTheme as C } from "./hooks.js";
import { useThemeVariant as B, ThemeVariant as k } from "./theme-variant-context.js";
import { Text3 as I, Text2 as R } from "./text.js";
import T from "./generated/mistica-icons/icon-close-regular.js";
import { IconButton as N } from "./icon-button.js";
import S from "classnames";
import y from "./button-group.js";
import { container as V, content as j, closeButtonContainerSize as A, closeButtonContainer as P } from "./callout.css-mistica.js";
import { vars as $ } from "./image.css-mistica.js";
import { sprinkles as w } from "./sprinkles.css-mistica.js";
import { vars as o } from "./skins/skin-contract.css-mistica.js";
import { getPrefixedDataAttributes as z } from "./utils/dom.js";
import { applyCssVars as D } from "./utils/css.js";
const G = (param)=>{
    let { title: a, titleAs: c = "h2", description: d, icon: i, onClose: t, closeButtonLabel: p, button: l, secondaryButton: s, buttonLink: n, "aria-label": u, dataAttributes: f, role: h } = param;
    const g = B(), { texts: b } = C();
    return /* @__PURE__ */ r("section", _object_spread_props(_object_spread({
        className: S(V, w({
            background: {
                inverse: o.colors.backgroundContainer,
                alternative: o.colors.backgroundContainer,
                default: o.colors.backgroundContainerAlternative
            }[g]
        })),
        style: D({
            [$.mediaBorderRadius]: o.borderRadii.mediaSmall
        }),
        "aria-label": u !== null && u !== void 0 ? u : a,
        role: h
    }, z(f, "Callout")), {
        children: /* @__PURE__ */ e(k, {
            isInverse: !1,
            children: [
                i && /* @__PURE__ */ r(x, {
                    paddingRight: 16,
                    children: i
                }),
                /* @__PURE__ */ e("div", {
                    className: j,
                    children: [
                        /* @__PURE__ */ e(m, {
                            space: 16,
                            children: [
                                /* @__PURE__ */ e(v, {
                                    fullWidth: !0,
                                    alignItems: "flex-start",
                                    space: "between",
                                    children: [
                                        /* @__PURE__ */ e(m, {
                                            space: 4,
                                            children: [
                                                /* @__PURE__ */ r(I, {
                                                    as: c,
                                                    regular: !0,
                                                    children: a
                                                }),
                                                /* @__PURE__ */ r(R, {
                                                    as: "p",
                                                    regular: !0,
                                                    color: o.colors.textSecondary,
                                                    children: d
                                                })
                                            ]
                                        }),
                                        t && // Create empty div in order to fill space that iconButton occupies.
                                        // Without this, the content's vertical alignment can be affected
                                        /* @__PURE__ */ r("div", {
                                            className: A
                                        })
                                    ]
                                }),
                                (l || s || n) && /* @__PURE__ */ r(y, {
                                    primaryButton: l,
                                    secondaryButton: s,
                                    link: n
                                })
                            ]
                        }),
                        t && /* @__PURE__ */ r("div", {
                            className: P,
                            children: /* @__PURE__ */ r(N, {
                                small: !0,
                                bleedY: !0,
                                bleedRight: !0,
                                Icon: T,
                                onPress: t,
                                "aria-label": p !== null && p !== void 0 ? p : b.closeButtonLabel
                            })
                        })
                    ]
                })
            ]
        })
    }));
}, er = G;
export { er as default };
